import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Menu from './pages/Menu';
import TableOrder from './components/TableOrder'; // Import your new page
import Header from './components/Header';
import MenuHeader from './components/MenuHeader';
import Footer from './components/Footer';
import ScrollToHash from './components/ScrollToHash';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Contactus from './pages/Contactus';

const Layout = () => {
  const location = useLocation();

  const renderHeader = () => {
    // Hide header completely for table orders to look like a clean Web App
    if (location.pathname === '/table') {
      return null; 
    }
    if (location.pathname === '/menu') {
      return <MenuHeader />;
    }
    return <Header />;
  };

  const renderFooter = () => {
    // Hide footer on table ordering page for better mobile experience
    if (location.pathname === '/table') return null;
    return <Footer />;
  }

  return (
    <>
      {renderHeader()}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/table" element={<TableOrder />} /> {/* The new route */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/Contactus" element={<Contactus />} />
        </Routes>
      </main>
      {renderFooter()}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToHash />
      <Layout />
    </Router>
  );
};

export default App;